module.exports = __webpack_public_path__ + "static/media/explosion.06da50d9.gif";